import { render, staticRenderFns } from "./ManageSourceParcelOverlappingModal.vue?vue&type=template&id=dd268632&scoped=true&"
import script from "./ManageSourceParcelOverlappingModal.vue?vue&type=script&lang=ts&"
export * from "./ManageSourceParcelOverlappingModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSourceParcelOverlappingModal.vue?vue&type=style&index=0&id=dd268632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd268632",
  null
  
)

export default component.exports